'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getBetaGroup();
  }

  getBetaGroup() {
    this.$http.get(`/api/betaGroups/${this.$stateParams.id}`).then(res => {
      this.betagroup = res.data;
    });
  }

  save() {
    this.$http.put(`/api/betaGroups/${this.$stateParams.id}`, this.betagroup).then(res => {
      this.$state.go('^');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/betagroups/edit/edit.controller.js